import { ACCOUNT_ACTIVATION_ERROR_CODES } from "@/features/account-activation/constants/error-codes";
import { CLIENT_CONSENT_ERROR_CODES } from "@/features/client-consent/constants/error-codes";
import { LOGIN_ERROR_CODES } from "@/features/login/constants/error-codes";
import { REGISTRATION_ERROR_CODES } from "@/features/registration/constants/error-codes";
import { RESET_PASSWORD_ERROR_CODES } from "@/features/reset-password/constants/error-codes";
import { VERIFY_EMAIL_ERROR_CODES } from "@/features/verify-email/constants/error-codes";
import { HOME_ERROR_CODES } from "@/features/home/constants/error-codes";

/**
 * Central error code mapping registry
 *
 * Aggregates all feature-specific error code mappings into a single dictionary.
 * The backend returns errors in RFC 7807 Problem Details format,
 * where the `title` field contains the error code (e.g., "Password.Reset").
 *
 * Each feature maintains its own error codes in:
 * - features/{feature-name}/constants/error-codes.ts
 *
 * This central registry combines them all for use in the API client.
 */
export const ERROR_CODE_MESSAGES: Record<string, string> = {
  ...LOGIN_ERROR_CODES,
  ...REGISTRATION_ERROR_CODES,
  ...RESET_PASSWORD_ERROR_CODES,
  ...VERIFY_EMAIL_ERROR_CODES,
  ...HOME_ERROR_CODES,
  ...ACCOUNT_ACTIVATION_ERROR_CODES,
  ...CLIENT_CONSENT_ERROR_CODES,
  // Add more feature error codes here as they are created:
  // ...FORGOT_PASSWORD_ERROR_CODES,
};
